import { connect } from "react-redux";
import CarerIncidentReport from "../components/CarerApp/CarerIncidentReport";
import { mapStateToProps, mapDispatchToProps } from "./CarerAppContainer";

export default connect(mapStateToProps, mapDispatchToProps)(CarerIncidentReport);
